import { FC, ReactNode, PropsWithChildren } from 'react';
import { HeadProvider, Title } from 'react-head';

import PageErrorWrapper from 'src/components/PageErrorWrapper';

interface PageLayoutProps extends PropsWithChildren {
    title: ReactNode;
}

const PageLayout: FC<PageLayoutProps> = ({ children, title }) => {
    const headTags = [<Title key="title">{title}</Title>];

    return (
        <PageErrorWrapper>
            {title && <HeadProvider headTags={headTags}>{headTags.map((headTag) => headTag)}</HeadProvider>}
            {children}
        </PageErrorWrapper>
    );
};

export default PageLayout;
